export default [
    {
        path: '/jingpin/list',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/jingpin/list.vue'),
        meta: {
            title: '竞争对手列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/jingpin/detail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/jingpin/detail.vue'),
    },
    {
        path: '/jingpin/detailall',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/jingpin/detailall.vue'),
        meta: {
            title: '竞品列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
]
